"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var react_1 = tslib_1.__importStar(require("react"));
var contexts_1 = require("../../contexts");
var NavigationBar_1 = tslib_1.__importDefault(require("./NavigationBar"));
var AppLogo_1 = require("../AppLogo");
var AppMenuWrapper_1 = tslib_1.__importDefault(require("./AppMenuWrapper"));
var MainHeaderWrapper_1 = tslib_1.__importDefault(require("./MainHeaderWrapper"));
var PhoneNum_1 = tslib_1.__importDefault(require("./PhoneNum"));
var UserAction_1 = tslib_1.__importDefault(require("./UserAction"));
var homepage = 'https://www.alintaenergy.com.au/';
var EmptySpace = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-left: auto;\n"], ["\n  margin-left: auto;\n"])));
var defaultLogo = 'https://www.alintaenergy.com.au/-/media/alinta-website/data/media/img/alinta_default_logo.png';
var AppMenu = function (_a) {
    var navSections = _a.navSections, phone = _a.phone, user = _a.user, login = _a.login, logout = _a.logout, _b = _a.homeLink, homeLink = _b === void 0 ? homepage : _b, _c = _a.logoSrc, logoSrc = _c === void 0 ? defaultLogo : _c, rightChildren = _a.rightChildren;
    var currentSize = react_1.useContext(contexts_1.ResponsiveContext);
    var navigationBar = navSections && navSections.length ? react_1.default.createElement(NavigationBar_1.default, { navSections: navSections }) : null;
    return (react_1.default.createElement(AppMenuWrapper_1.default, { "aria-label": "standard navigation" },
        react_1.default.createElement(MainHeaderWrapper_1.default, { pad: currentSize === 'lg' ? { horizontal: 'large' } : { left: 'medium' } },
            react_1.default.createElement("a", { href: homeLink },
                react_1.default.createElement(AppLogo_1.AppLogo, { size: currentSize, src: logoSrc, alt: "Alinta-energy-logo", "data-testid": "app-logo" })),
            currentSize !== 'xs' && navigationBar,
            react_1.default.createElement(EmptySpace, null),
            rightChildren,
            phone ? react_1.default.createElement(PhoneNum_1.default, { phone: phone }) : null,
            user !== undefined && login && logout ? react_1.default.createElement(UserAction_1.default, { user: user, login: login, logout: logout }) : null),
        currentSize === 'xs' && navigationBar));
};
exports.default = AppMenu;
var templateObject_1;
//# sourceMappingURL=AppMenu.js.map